import { Component, forwardRef, inject, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {RecordsTableService} from '../../../core/services/records-table.service';
import {ResourceParams, resources, ResourceTypes} from "../../../core/models/resource/resources";
import {AuthService} from "../../../core/services/auth.service";
import {CurrentUserRoleAndLogin} from "../../../core/types/auth.types";
import {FiltersVisibilityService} from "../../../core/services/filters-visibility.service";
import {TableContextService} from "../../../core/services/table-services/table-context.service";
import {
  RecordsTableContainerComponent
} from "../../../core/components/records-table-container/records-table-container.component";
import { PageInfoComponent } from "../../../core/components/page-info/page-info.component";

@Component({
  selector: 'app-table-page',
  standalone: true,
  imports: [
    RecordsTableContainerComponent,
    forwardRef(() => RecordsTableContainerComponent),
    PageInfoComponent
  ],
  templateUrl: './table-page.component.html',
  styleUrl: './table-page.component.scss',
  providers: [ TableContextService ]
})
export class TablePageComponent implements OnInit {
  private recordsTableService: RecordsTableService = inject(RecordsTableService);
  private activatedRoute: ActivatedRoute = inject(ActivatedRoute);
  private router: Router = inject(Router);
  private authService: AuthService = inject(AuthService);
  private filtersVisibilityService: FiltersVisibilityService = inject(FiltersVisibilityService);

  public currentResourceParams: ResourceParams | null = null;
  public loginAndRoles: CurrentUserRoleAndLogin | null = null;

  public get resourceName(): string {
    if (!this.currentResourceParams) { return ''; }

    return this.currentResourceParams.name;
  }

  public ngOnInit(): void {
    this.loginAndRoles = this.authService.getRolesAndLogin();
    this.initRouteChangeSubscription();
  }

  private initRouteChangeSubscription(): void {
    this.activatedRoute.params.subscribe(async (params: { [key: string]: ResourceTypes }) => {
      this.currentResourceParams = resources[params['resourceType']];
      this.filtersVisibilityService.resetFilterVisibility();

      if (this.isPromotionSpecialistRole()) {
        await this.redirectToPromotionSpecialist();
        return;
      }

      await this.handleDefaultCase();
    });
  }

  private isPromotionSpecialistRole(): boolean {
    return this.loginAndRoles?.role === 'ROLE_PROMOTION_SPECIALIST';
  }

  private async redirectToPromotionSpecialist(): Promise<void> {
    this.currentResourceParams = resources['record-calendars-promotion-specialist'];
    await this.router.navigate(['/records/record-calendars-promotion-specialist']);
  }

  private async handleDefaultCase(): Promise<void> {
    if (!this.currentResourceParams) {
      await this.router.navigate(['/404']);
      return;
    }

    this.recordsTableService.setCurrentResourceType(this.currentResourceParams);
  }
}
